import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@src/framework/workbench/common/feature/base-toolbar-feature';
import type { IInsertCommentFeature } from './insert-comment-interface';
import { config } from './config';
import { CommentShowAction, ShowActionSource } from '@src/js/constant';
import { EventCodeType, TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { getCacConfigByKey } from '@src/slide/infrastructure/module/dependent/config/tob/app-config';

@Feature()
export class InsertCommentFeature extends BaseToolbarFeature implements IInsertCommentFeature {
    public id = config.id;
    public config = config;
    public constructor() {
        super();
    }

    public handleInsertComment(): void {
        this.getAppService().viewableServiceLayer.commentManager.promise()
            .then((commentManager) => {
                commentManager.setCommentShowAction(CommentShowAction.INSERT_COMMENT, ShowActionSource.TOOLBAR);
            });
        this.report(TDWActionType.ADD_COMMENTS, EventCodeType.DOC_PPT_REVIEW_TAB_ADD_COMMENTS);
    }

    public shouldHide(): boolean {
        return !!this.getAppService().editableServiceLayer?.masterLayoutEditService.isMasterEditType
            || !getCacConfigByKey('feature.comment', false);
    }

    public shouldDisabled(id: string): boolean {
        if (super.shouldDisabled(id)) {
            return true;
        }
        const selectionService = this.getAppService().viewableServiceLayer?.selectionService;
        return !!(selectionService?.selectedSlides.selectedArray.some(e => e.preload)
            || selectionService?.currentSlide?.preload);
    }

    private report(action, eventcode) {
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.TOOLBAR_REVIEW_TAB,
            ver3: 1,    // menu
            ver5: this.getSelectModel()?.type,
            action,
            eventcode,
        });
    }
}
